import { PasswordPolicy } from 'password-sheriff'

export interface PasswordService {
    loadPasswordValidator(): Promise<PasswordPolicy>
}
